import { render, staticRenderFns } from "./user-select.vue?vue&type=template&id=8bff92da&scoped=true"
import script from "./user-select.vue?vue&type=script&lang=ts"
export * from "./user-select.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8bff92da",
  null
  
)

export default component.exports